module.exports = __webpack_public_path__ + "img/logo.f9e0a511.png";